import React from 'react'
import { useFetchedState } from '..'
import { StateWrapper, StateWrapperProps, WrapperProps } from '../../components'
import { FetchHookProps, StatusType } from './types'

type StateWrapperHookProps<T> = FetchHookProps &
  Pick<StateWrapperProps<T>, 'fetchErrorType'>

export const useStateWrapper = <T,>({
  fetchErrorType,
  ...fetchHookProps
}: StateWrapperHookProps<T>) => {
  const { fetchedState, execute } = useFetchedState<T>({ ...fetchHookProps })

  const data =
    fetchedState?.status === StatusType.FETCHED ? fetchedState.data : undefined

  const StateRenderWrapper = ({ children }: WrapperProps) => {
    return (
      <StateWrapper fetchErrorType={fetchErrorType} fetchState={fetchedState}>
        {children}
      </StateWrapper>
    )
  }

  return { StateRenderWrapper, data, execute }
}
